<div class="flex flex-row lt-lg:flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
  <app-feature-list-container class="flex-[65%] max-w-[65%] lt-lg:flex-[100%] lt-lg:max-w-[100%]">
    <div class="flex flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
      <div class="commissioning-title-secondary">
        {{
          selectedDevice === deviceType.VITOCONNECT
            ? ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.VITOCONNECT.HEADER' | translate)
            : ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.ONE_BASE.HEADER' | translate)
        }}
      </div>
      <div>
        {{
          selectedDevice === deviceType.VITOCONNECT
            ? ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.VITOCONNECT.SUB_HEADER' | translate)
            : ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.ONE_BASE.SUB_HEADER' | translate)
        }}
      </div>

      <mat-divider></mat-divider>

      <app-gateway-form
        [formData]="formData"
        (gatewayDataChange)="onGatewayDataChange($event)"
      ></app-gateway-form>

      <mat-divider></mat-divider>

      <app-description-form
        [formData]="formData"
        [isMandatory]="commissioningFlowSelected === commissioningFlow.COMMERCIAL"
        (descriptionChange)="onDescriptionChange($event)"
      ></app-description-form>

      <mat-divider></mat-divider>

      <app-address-form
        [formData]="formData"
        (addressDataChange)="onAddressDataChange($event)"
      ></app-address-form>

      <mat-divider></mat-divider>

      <ng-container
        *ngIf="
          isVitoconnectOpenTherm && commissioningFlowSelected === commissioningFlow.RESIDENTIAL
        "
      >
        <app-heating-type-form
          [selectedHeatingType]="selectedHeatingType"
          (heatingTypeChange)="onChangeHeatingType($event)"
        ></app-heating-type-form>

        <mat-divider></mat-divider>
      </ng-container>

      <app-oma-function-form
        *ngIf="commissioningFlowSelected === commissioningFlow.RESIDENTIAL"
        [formData]="formData"
        (omaFunctionDataChange)="onOmaFunctionDataChange($event)"
      ></app-oma-function-form>

      <app-owner-administrator-form
        *ngIf="commissioningFlowSelected === commissioningFlow.COMMERCIAL"
        [formData]="formData"
        (ownerAdministratorDataChange)="onOwnerAdministratorDataChange($event)"
      ></app-owner-administrator-form>
    </div>
  </app-feature-list-container>

  <div
    class="steps-wrapper flex flex-col gap-[24px] xs:gap-[16px] flex-1 lt-lg:flex-[100%] lt-lg:max-w-[100%]"
  >
    <div class="flex flex-col gap-[24px] xs:gap-[16px]">
      <div class="flex flex-col md:flex-row gap-[24px] xs:gap-[16px]">
        <app-edit-commissioning-step
          class="flex-1"
          [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.TITLE'"
          [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.COMPLETED'"
          [showEditButton]="true"
          [displayConfirmDialog]="true"
          (previousStep)="previousStepClicked(commissioningStep.SELECT_INSTALLATION_TYPE)"
        ></app-edit-commissioning-step>
        <app-edit-commissioning-step
          class="flex-1"
          [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_CONNECTION.TITLE'"
          [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_CONNECTION.COMPLETED'"
          [showEditButton]="true"
          (previousStep)="previousStepClicked(commissioningStep.INSTRUCTIONS)"
        ></app-edit-commissioning-step>
      </div>
      <app-edit-commissioning-step
        *ngIf="selectedDevice === deviceType.VITOCONNECT"
        class="flex-1"
        [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_VALIDATION.TITLE'"
        [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_VALIDATION.COMPLETED'"
        [showEditButton]="true"
        (previousStep)="previousStepClicked(commissioningStep.CHECK_LIGHT)"
      ></app-edit-commissioning-step>
    </div>

    <ng-container
      *ngIf="!(gatewayCommissioningStore.transferInstallationLoading$ | async); else loading"
    >
      <button
        *ngIf="
          isGrandmaFunctionSelected && commissioningFlowSelected === commissioningFlow.RESIDENTIAL
        "
        class="next-step-btn flex-1"
        gtm="onConfirm"
        gtmAction="Transfer oma form"
        gtmCategory="gatewayCommissioningOMAForm"
        data-at-transfer-oma-installation-btn
        mat-raised-button
        color="primary"
        (click)="transferOMA()"
        [disabled]="
          (gatewayCommissioningStore.selectGatewayVerificationError$ | async) ||
          (gatewayCommissioningStore.isGatewayVerificationOngoing$ | async) ||
          (gatewayCommissioningStore.isGatewayVerificationDataRegistered$ | async) ||
          !(
            isOmaFunctionFormValid &&
            isAddressFormValid &&
            isGatewayFormValid &&
            isDescriptionValid
          ) ||
          (isVitoconnectOpenTherm && !selectedHeatingType) ||
          isMissingCertificateActive
        "
      >
        {{ '+GATEWAY_COMMISSIONING_REDESIGN.BTN_FINISH_COMMISSIONING' | translate }}
      </button>

      <button
        *ngIf="
          !isGrandmaFunctionSelected && commissioningFlowSelected === commissioningFlow.RESIDENTIAL
        "
        class="next-step-btn flex-1"
        [disabled]="
          (gatewayCommissioningStore.selectGatewayVerificationError$ | async) ||
          (gatewayCommissioningStore.isGatewayVerificationOngoing$ | async) ||
          (gatewayCommissioningStore.isGatewayVerificationDataRegistered$ | async) ||
          !(isEmailFormValid && isAddressFormValid && isGatewayFormValid && isDescriptionValid) ||
          (isVitoconnectOpenTherm && !selectedHeatingType) ||
          isMissingCertificateActive
        "
        gtm="onConfirm"
        gtmAction="Transfer email form"
        gtmCategory="gatewayCommissioningEmailForm"
        data-at-transfer-installation-btn
        mat-raised-button
        color="primary"
        (click)="transfer()"
      >
        {{ '+GATEWAY_COMMISSIONING_REDESIGN.BTN_FINISH_COMMISSIONING' | translate }}
      </button>

      <button
        *ngIf="commissioningFlowSelected === commissioningFlow.COMMERCIAL"
        class="next-step-btn flex-1"
        [disabled]="
          (gatewayCommissioningStore.selectGatewayVerificationError$ | async) ||
          (gatewayCommissioningStore.isGatewayVerificationOngoing$ | async) ||
          (gatewayCommissioningStore.isGatewayVerificationDataRegistered$ | async) ||
          (!isOwnerOfTheInstallationSelected &&
            !(
              isEmailFormValid &&
              isAddressFormValid &&
              isGatewayFormValid &&
              isDescriptionValid
            )) ||
          (isOwnerOfTheInstallationSelected &&
            !(isAddressFormValid && isGatewayFormValid && isDescriptionValid))
        "
        gtm="onConfirm"
        gtmAction="Transfer commercial form"
        gtmCategory="gatewayCommissioningEmailForm"
        data-at-transfer-commercial-installation-btn
        mat-raised-button
        color="primary"
        (click)="commercialTransfer()"
      >
        {{ '+GATEWAY_COMMISSIONING_REDESIGN.BTN_FINISH_COMMISSIONING' | translate }}
      </button>
    </ng-container>

    <ng-template #loading
      ><vi-loader
        [isLoading]="true"
        [message]="'+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.LOADER_TEXT' | translate"
      ></vi-loader>
    </ng-template>
  </div>
</div>
